import styled, { css } from 'styled-components';

interface ButtonProps {
  title?: string;
  price?: string;
  color?: 'primary' | 'secondary' | 'disable' | 'share' | 'confirm';
  onClick: () => void;
}

const COLOR = {
  primary: css`
    background: #11497e;
  `,
  secondary: css`
    background: #4b4b4b;
  `,
  disable: css`
    background: #b7b7b7;
  `,
  share: css`
    background: #ff5f98;
  `,
  confirm: css`
    background: rgb(0, 134, 255);
  `,
};

const Button = ({ title, price, color = 'primary', onClick }: ButtonProps) => {
  return (
    <ButtonTemplate onClick={onClick} color={color}>
      <TitleText>{title}</TitleText>
      <PriceText>{price}</PriceText>
    </ButtonTemplate>
  );
};

const ButtonTemplate = styled.button<ButtonProps>`
  width: 100%;
  height: 40px;
  border-radius: 8px;
  font-style: normal;
  text-align: center;
  border: none;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  ${(props) => props.color && COLOR[props.color]}
`;
const TitleText = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #ffffff;
`;
const PriceText = styled.div`
  position: absolute;
  right: 20px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #ffffff;
  border: none;
`;

export default Button;
